export default __webpack_public_path__ + "static/media/plain-sticker-M.4764ae5d.png";